import React from "react";
import { Accordion, Tab, Tabs } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";
import { useEmailBuilderContext } from "../../../../../Context/EmailBuilderContext";

export const Sidebar = () => {
  const { setFormData } = useEmailBuilderContext();
  return (
    <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">
      <Tabs defaultActiveKey="elements" id="fill-tab-example" className="mb-3">
        <Tab eventKey="elements" title="Elements">
          <div className="search-div mb-3">
            <div className="input-group">
              <span className="input-group-text">
                <i className="pluto-search"></i>
              </span>
              <input
                type="search"
                className="form-control"
                placeholder="Search element"
              />
            </div>
          </div>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Text Elements</Accordion.Header>
              <Accordion.Body>
                <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                  <Draggable key="shortText" draggableId="shortText">
                    {(provided) => (
                      <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        className="btn btn-gray-light btn-sm"
                      >
                        <span className="material-symbols-outlined align-middle">
                          notes
                        </span>{" "}
                        Short text
                      </div>
                    )}
                  </Draggable>

                  <div className="btn btn-gray-light btn-sm">
                    <span className="material-symbols-outlined align-middle">
                      subject
                    </span>{" "}
                    Long text
                  </div>
                  <div className="btn btn-gray-light btn-sm">
                    <span className="material-symbols-outlined align-middle bx-sm">
                      123
                    </span>{" "}
                    Number
                  </div>
                  <div className="btn btn-gray-light btn-sm">
                    <span className="material-symbols-outlined align-middle">
                      info
                    </span>{" "}
                    Description
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};
